<template>
  <div id="navigationbar">
   <nav class="navbar navbar-expand-lg fixed-top navbar-dark" style="background-color: #25455b;">
      <router-link to="/home"><img  src="../assets/lp_long_small.png" alt="" width="155" height="45"></router-link>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample04" aria-controls="navbarsExample04" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarsExample04">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/home">Home</router-link>
          </li>
          
          <li class="nav-item">
            <router-link class="nav-link" to="/investments">Investments</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/info">Contact Info</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/goals">Goals</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/financials">Financial Information</router-link>
          </li>
                    <li class="nav-item">
            <router-link class="nav-link" to="/transactions">Transactions</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/vault">Vault</router-link>
          </li>
        </ul>
        <ul class="nav-item justify-content-end">
            <button id="signout" class="btn btn-sm btn-outline-light" type="button" @click="logout">Sign out</button>
        </ul>
      </div>
    </nav>

  </div>
</template>
<script>
import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/database');
require('@firebase/firestore');
require('@firebase/functions');
require('@firebase/messaging');
require('@firebase/storage');
require('@firebase/performance');
export default {
    methods:{
    logout: function(){
      firebase.auth().signOut().then(() => {
        this.$router.replace('login')
      })
    }
  },
  data:()=>({
    activeItem: 0
  })
}

</script>

<style >
body {
  font-size: .875rem;
}

#signout {
padding-top: 5px;

}



.feather {
  width: 16px;
  height: 16px;
  vertical-align: text-bottom;
}

.navbar-nav > li{
  margin-left:5px;
  margin-right:5px;
}

/*
 * Utilities
 */

.border-top { border-top: 1px solid #e5e5e5; }
.border-bottom { border-bottom: 1px solid #e5e5e5; }

</style>